import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class AmbientProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    if (ctx.scale.length >= 7) {
      const choice = this.pick(ctx, [[0, 0, 0, 0], [0, 3], [0, 5], [0, 0, 3, 3]]);
      return choice.map(deg => this.triad(ctx, deg));
    }
    return [this.triad(ctx, 0)];
  }
}
